import React from "react";
import cn from "classnames";
import styles from "./gateway-machines-list-header.module.scss";
import { useI18N } from "@src/language/language-context";

const cssClassName = "gateway-machines-list-header";

export const GatewayMachinesListHeader = () => {
  const i18n = useI18N();

  const texts = {
    statusAndMachineName: i18n(
      "modules.gatewayMachinesListHeader.statusAndMachineName",
    ),
    machineId: i18n("modules.gatewayMachinesListHeader.machineId"),
    dsnAddress: i18n("modules.gatewayMachinesListHeader.dsnAddress"),
    statusAndGatewayName: i18n(
      "modules.gatewayMachinesListHeader.statusAndGatewayName",
    ),
  };

  return (
    <thead>
      <tr className={styles[`${cssClassName}__header`]}>
        <td
          className={cn(
            styles[`${cssClassName}__grid-cell`],
            styles[`${cssClassName}__grid-cell-header`],
          )}
        >
          {texts.statusAndMachineName} {/* <QuestionMarkWithPopover /> */}
        </td>

        <td
          className={cn(
            styles[`${cssClassName}__grid-cell`],
            styles[`${cssClassName}__grid-cell-header`],
          )}
        >
          {texts.machineId}
        </td>
        <td
          className={cn(
            styles[`${cssClassName}__grid-cell`],
            styles[`${cssClassName}__grid-cell-header`],
          )}
        >
          {texts.dsnAddress}
        </td>
        {/* <td
          className={cn(
            styles[`${cssClassName}__grid-cell`],
            styles[`${cssClassName}__grid-cell-header`],
          )}
        >
          {texts.statusAndGatewayName}
        </td> */}
      </tr>
    </thead>
  );
};
